/**
 * User Guidance Tips Data
 *
 * This file contains the tips shown to users on their first visit to each screen.
 * Tips are displayed as persistent info banners that can be dismissed.
 */

export type ScreenId = 'product-selection' | 'ai-mode' | 'manual-mode' | 'library-mode';

export interface GuidanceTip {
  id: string;
  screen: ScreenId;
  title: string;
  description: string;
}

/**
 * Guidance tips for each screen in the application.
 * These are shown on first visit and can be dismissed by the user.
 */
export const guidanceTips: Record<ScreenId, GuidanceTip> = {
  'product-selection': {
    id: 'tip-product-selection',
    screen: 'product-selection',
    title: 'Choose Your Product',
    description:
      'Select a product to start designing. Prices include custom engraving and standard shipping.',
  },
  'ai-mode': {
    id: 'tip-ai-mode',
    screen: 'ai-mode',
    title: 'AI Design Generator',
    description:
      'Get 5 free AI designs when you create an account — then just 10¢ each. Choose a Template and Layout, then fill in your details to generate.',
  },
  'manual-mode': {
    id: 'tip-manual-mode',
    screen: 'manual-mode',
    title: 'Manual Editor',
    description:
      'Upload images, add text, and draw freely. Use layers to organize your design. Press ? for keyboard shortcuts.',
  },
  'library-mode': {
    id: 'tip-library-mode',
    screen: 'library-mode',
    title: 'Your Design Library',
    description:
      "View saved projects, designs, and auto-saves. Share your work with the community or browse others' designs.",
  },
};

/**
 * Get a guidance tip by screen ID
 */
export function getGuidanceTip(screenId: ScreenId): GuidanceTip {
  return guidanceTips[screenId];
}

/**
 * Get all guidance tips as an array
 */
export function getAllGuidanceTips(): GuidanceTip[] {
  return Object.values(guidanceTips);
}
